import { TradeInAemModelSelectType } from "../../utils/constants";
import { type TradeInAemLabelType, tradeInAemLabels } from "../../utils/labels";
import { type TradeInAemSettingsActionsType, TRADE_IN_AEM_SETTINGS_INIT } from "../actions/TradeInAemSettingsActions";

export type TradeInAemSettingsType = {
    initialized: boolean;
    tradeInGateway: string;
    newModelList: string[];
    stockModelList: string[];
    vehicleDetailsFormConfig: string | null; // If available this contains a stringified JSON object to be used in getVehicleDetailFormItems csl.
    backToWebsiteUrl: string;
    modelSelectBlocks: TradeInAemModelSelectType[];
    enablePdf: boolean;
    labels: Record<TradeInAemLabelType, string>;
};

export const initialStateTradeInAem: TradeInAemSettingsType = {
    initialized: false,
    tradeInGateway: "",
    newModelList: [],
    stockModelList: [],
    vehicleDetailsFormConfig: null,
    backToWebsiteUrl: "",
    modelSelectBlocks: [
        TradeInAemModelSelectType.New,
        TradeInAemModelSelectType.Stock,
        TradeInAemModelSelectType.Used,
        TradeInAemModelSelectType.None,
    ],
    enablePdf: false,
    labels: { ...tradeInAemLabels },
};

const TradeInAemSettingsReducer = (
    state: TradeInAemSettingsType = initialStateTradeInAem,
    action: TradeInAemSettingsActionsType,
): TradeInAemSettingsType => {
    switch (action.type) {
        case TRADE_IN_AEM_SETTINGS_INIT:
            return { ...state, ...action.initState, initialized: true };

        default:
            return state;
    }
};

export default TradeInAemSettingsReducer;
